function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "e2bf1f7d-47c1-4d5e-a8e7-eb090eb66cd5",
  x1: 722.82,
  y1: 71.75,
  x2: 722.82,
  y2: 27.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a3595478-8223-4729-894e-2a36a16c8458",
  x1: 885.66,
  y1: 728.42,
  x2: 885.66,
  y2: 125.42,
  xlinkHref: "#e2bf1f7d-47c1-4d5e-a8e7-eb090eb66cd5"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 160.32,
  y: 408.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 263.32,
  y: 408.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 263.32,
  y: 408.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 366.32,
  y: 408.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 469.32,
  y: 408.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 469.32,
  y: 408.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 572.32,
  y: 408.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 675.32,
  y: 408.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 675.32,
  y: 408.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 755.16,
  y: 492.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1533.48 900.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 652.16,
  y: 492.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1327.48 900.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 652.16,
  y: 492.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1327.48 900.74) rotate(-180)",
  opacity: 0.1
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 549.16,
  y: 492.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1121.48 900.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 446.16,
  y: 492.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(915.48 900.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 446.16,
  y: 492.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(915.48 900.74) rotate(-180)",
  opacity: 0.1
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 343.16,
  y: 492.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(709.48 900.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 240.16,
  y: 492.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(503.48 900.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 240.16,
  y: 492.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(503.48 900.74) rotate(-180)",
  opacity: 0.1
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 160.32,
  y: 326.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 263.32,
  y: 326.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 263.32,
  y: 326.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 366.32,
  y: 326.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 469.32,
  y: 326.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 469.32,
  y: 326.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 572.32,
  y: 326.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 675.32,
  y: 326.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 675.32,
  y: 326.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 755.16,
  y: 410.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1533.48 736.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 652.16,
  y: 410.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1327.48 736.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 652.16,
  y: 410.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1327.48 736.74) rotate(-180)",
  opacity: 0.1
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 549.16,
  y: 410.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1121.48 736.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 446.16,
  y: 410.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(915.48 736.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 446.16,
  y: 410.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(915.48 736.74) rotate(-180)",
  opacity: 0.1
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 343.16,
  y: 410.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(709.48 736.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 240.16,
  y: 410.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(503.48 736.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 240.16,
  y: 410.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(503.48 736.74) rotate(-180)",
  opacity: 0.1
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 160.32,
  y: 246.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 263.32,
  y: 246.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 263.32,
  y: 246.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 366.32,
  y: 246.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 469.32,
  y: 246.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 469.32,
  y: 246.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  x: 572.32,
  y: 246.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 675.32,
  y: 246.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 675.32,
  y: 246.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 755.16,
  y: 330.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1533.48 576.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 652.16,
  y: 330.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1327.48 576.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  x: 652.16,
  y: 330.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1327.48 576.74) rotate(-180)",
  opacity: 0.1
});

var _ref51 = /*#__PURE__*/React.createElement("rect", {
  x: 549.16,
  y: 330.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1121.48 576.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref52 = /*#__PURE__*/React.createElement("rect", {
  x: 446.16,
  y: 330.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(915.48 576.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref53 = /*#__PURE__*/React.createElement("rect", {
  x: 446.16,
  y: 330.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(915.48 576.74) rotate(-180)",
  opacity: 0.1
});

var _ref54 = /*#__PURE__*/React.createElement("rect", {
  x: 343.16,
  y: 330.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(709.48 576.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref55 = /*#__PURE__*/React.createElement("rect", {
  x: 240.16,
  y: 330.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(503.48 576.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref56 = /*#__PURE__*/React.createElement("rect", {
  x: 240.16,
  y: 330.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(503.48 576.74) rotate(-180)",
  opacity: 0.1
});

var _ref57 = /*#__PURE__*/React.createElement("rect", {
  x: 160.32,
  y: 164.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref58 = /*#__PURE__*/React.createElement("rect", {
  x: 263.32,
  y: 164.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref59 = /*#__PURE__*/React.createElement("rect", {
  x: 263.32,
  y: 164.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref60 = /*#__PURE__*/React.createElement("rect", {
  x: 366.32,
  y: 164.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref61 = /*#__PURE__*/React.createElement("rect", {
  x: 469.32,
  y: 164.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref62 = /*#__PURE__*/React.createElement("rect", {
  x: 469.32,
  y: 164.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref63 = /*#__PURE__*/React.createElement("rect", {
  x: 572.32,
  y: 164.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref64 = /*#__PURE__*/React.createElement("rect", {
  x: 675.32,
  y: 164.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref65 = /*#__PURE__*/React.createElement("rect", {
  x: 675.32,
  y: 164.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  opacity: 0.1
});

var _ref66 = /*#__PURE__*/React.createElement("rect", {
  x: 667.32,
  y: 27.57,
  width: 111,
  height: 44.18,
  rx: 8.84,
  ry: 8.84,
  fill: "url(#e2bf1f7d-47c1-4d5e-a8e7-eb090eb66cd5)"
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  x: 751.16,
  y: 154.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1525.48 224.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref68 = /*#__PURE__*/React.createElement("rect", {
  x: 652.16,
  y: 248.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1327.48 412.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref69 = /*#__PURE__*/React.createElement("rect", {
  x: 652.16,
  y: 248.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1327.48 412.74) rotate(-180)",
  opacity: 0.1
});

var _ref70 = /*#__PURE__*/React.createElement("rect", {
  x: 549.16,
  y: 248.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(1121.48 412.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref71 = /*#__PURE__*/React.createElement("rect", {
  x: 446.16,
  y: 248.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(915.48 412.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref72 = /*#__PURE__*/React.createElement("rect", {
  x: 446.16,
  y: 248.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(915.48 412.74) rotate(-180)",
  opacity: 0.1
});

var _ref73 = /*#__PURE__*/React.createElement("rect", {
  x: 343.16,
  y: 248.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(709.48 412.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref74 = /*#__PURE__*/React.createElement("rect", {
  x: 240.16,
  y: 248.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(503.48 412.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref75 = /*#__PURE__*/React.createElement("rect", {
  x: 240.16,
  y: 248.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(503.48 412.74) rotate(-180)",
  opacity: 0.1
});

var _ref76 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 499,
  cy: 535.66,
  rx: 499,
  ry: 113.5,
  fill: "#f5f5f5"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M193.79,610.14s9-30.41-1.68-52.8a48,48,0,0,1-3.89-30.14,80.79,80.79,0,0,1,4.27-14.15",
  transform: "translate(-79.84 -125.42)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M185.87,498.91c0,3.73,6.75,14.54,6.75,14.54s6.75-10.81,6.75-14.54a6.75,6.75,0,0,0-13.5,0Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#00a08f"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M174.71,519.56c2,3.13,13.57,8.53,13.57,8.53s-.21-12.74-2.24-15.87a6.75,6.75,0,0,0-11.33,7.34Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#00a08f"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M175.2,554.84c3.33,1.68,16,.52,16,.52s-6.61-10.89-9.94-12.57a6.75,6.75,0,0,0-6.08,12.05Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#00a08f"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M181.58,581.45c3,2.22,15.7,3.22,15.7,3.22s-4.68-11.85-7.67-14.07a6.75,6.75,0,0,0-8,10.85Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#00a08f"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M202.45,528.81c-2.67,2.6-15.13,5.29-15.13,5.29s3.05-12.37,5.72-15a6.75,6.75,0,1,1,9.41,9.68Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#00a08f"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M209.52,560c-3.33,1.68-16,.52-16,.52s6.61-10.89,9.94-12.57A6.75,6.75,0,0,1,209.52,560Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#00a08f"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M212.22,591.32c-3,2.22-15.7,3.22-15.7,3.22s4.68-11.85,7.67-14.07a6.75,6.75,0,0,1,8,10.85Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#00a08f"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M676.82,437.8s32.89,32.89,14.32,81.69,31.83,130,31.83,130-.54-.08-1.54-.26C653.88,637.26,620.32,560,657.88,502.62,671.84,481.28,683.31,456.26,676.82,437.8Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#00a08f"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M676.82,437.8s32.89,32.89,14.32,81.69,31.83,130,31.83,130-.54-.08-1.54-.26C653.88,637.26,620.32,560,657.88,502.62,671.84,481.28,683.31,456.26,676.82,437.8Z",
  transform: "translate(-79.84 -125.42)",
  opacity: 0.2
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M676.82,437.8s18.57,40.31,0,73.2S673.64,636.18,723,649.44",
  transform: "translate(-79.84 -125.42)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M618.25,570.81s37.53-6,40.95,27.66,72.16,38.29,72.16,38.29l-1.29.86c-56.76,37.26-111,23.73-102.84-25.74C630.27,593.49,630,575,618.25,570.81Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#00a08f"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M618.25,570.81s37.53-6,40.95,27.66,72.16,38.29,72.16,38.29l-1.29.86c-56.76,37.26-111,23.73-102.84-25.74C630.27,593.49,630,575,618.25,570.81Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#f5f5f5",
  opacity: 0.2
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M618.25,570.81s29.13,6.39,26.74,32.88,43.26,58.24,86.37,33.07",
  transform: "translate(-79.84 -125.42)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M903.77,648.23s-55.7-11.14-70.56-26-81.7-40.85-89.13-22.28S643.82,681.66,707,692.8s148.54,14.85,167.11,7.43S903.77,648.23,903.77,648.23Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#a8a8a8"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M707,685.9c63.13,11.14,148.54,14.85,167.11,7.43,14.14-5.66,24-32.83,27.85-45.48l1.86.39s-11.14,44.56-29.71,52-104,3.71-167.11-7.43c-18.22-3.22-23.43-10.77-21.47-20.33C687,678.71,693.39,683.5,707,685.9Z",
  transform: "translate(-79.84 -125.42)",
  opacity: 0.2
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M1016.47,153.59a16.36,16.36,0,0,0-4.61-6.39c-14.95-13.62-39.12-9.49-57.68-17.82-4.28-1.92-8.66-4.58-13.3-3.85-6.48,1-12.51,8.4-18.16,5.12l.4,1.23-.4-.21,4.16,12.66c1.6,4.86,3.28,9.86,6.38,13.91a36.42,36.42,0,0,0,8.81,60.58c.2.42.39.85.58,1.28l.53.22a42.52,42.52,0,0,1,2.74,8.82c-4.81.67-13.2,6-21.44,13.84L908,242.43a53.94,53.94,0,0,1-29.64-10.08L829,196.9a16.51,16.51,0,0,0-9.45,4.18c-6.12-6.38-11.32-13-10.88-17,0,0-22.94-42.93-31.28-21.47s15.64,44,15.64,44l15.21,19.71a82.91,82.91,0,0,0-1.14,10.45c18.77,21.47,84.45,40.89,84.45,40.89l10.24.5.06.5a34.87,34.87,0,0,0-.92,8.2c0,.4,0,.81,0,1.23s0,.55,0,.82c.52,34.24,5.21,139,5.21,139,.91-.41,1.86-.78,2.82-1.13l-.73,9.31s-43.79,6.13-76.11,18.4-33.36,26.58-33.36,26.58V607.33c-9.23,4.74-23.8,11-31.28,7.63-8.12-3.62-12.57-.58-13.38,2.59h0a4,4,0,0,0,0,1.91v0a3.42,3.42,0,0,0,.31.81l0,.06a3.25,3.25,0,0,0,.55.72c3.13,3.07,70.9,29.64,86.54,25.55a10.81,10.81,0,0,0,1.42-.48c.15-.06.28-.14.43-.21s.58-.27.85-.43.31-.21.46-.31.47-.31.69-.48.29-.26.43-.39.41-.35.59-.55.26-.3.39-.45.36-.4.52-.62.22-.33.34-.49.32-.46.46-.7.19-.34.28-.52.28-.51.41-.78.16-.35.23-.53.25-.57.36-.86.12-.35.19-.53.22-.63.31-1c0-.17.09-.34.14-.51.09-.35.19-.69.27-1,0-.16.07-.32.1-.48.08-.38.16-.76.22-1.14,0-.14,0-.29.07-.43.07-.41.13-.83.18-1.24l0-.36c.05-.45.1-.9.14-1.35l0-.28q.06-.73.09-1.46v-.2q0-.78,0-1.56v-.1a85.59,85.59,0,0,0-2-18.13h0L853,501.5a586.59,586.59,0,0,0,61.36-2.26l2.24,51.32s0,33.73,11.47,49.06c9.82,13.12,21.16,71.15,24.22,87.62-4.21,8-12.27,18-26.31,17.66,0,0-26.41-2.28-24.92,5h0a3.74,3.74,0,0,0,.17.56l0,0a5.16,5.16,0,0,0,.29.61l0,0c.11.19.23.38.37.58l.08.12c.15.21.32.43.51.66l0,.05c.18.21.37.42.58.63l.18.18c.24.24.48.48.76.73,13.55,12.27,92.79,14.31,92.79,14.31v-.28c0-.08,0-.18,0-.29v0c0-3.55-.52-22.17-5.26-36.19h1.1s-11.47-103.24-20.85-115.5c0,0-2.49-54.44,3.13-88.55l1-.38c26.28-9.82,28.15-34,25.44-51.76,5,1.6,7.92,2.69,7.92,2.69s-.09-.77-.26-2.14l.26.1s-.5-3.25-1.33-8.31c-1.88-13.93-5.52-38.27-9.4-49.76-.63-2.53-1.23-4.69-1.78-6.32a108.06,108.06,0,0,1-4.59-21.23,251.65,251.65,0,0,1-1.61-28.16,270.27,270.27,0,0,1,2.88-37.56c1.59-10.86,3-23.22,2.9-31.85a42.47,42.47,0,0,0-.63-9c-1.39-6.37-7.54-10.51-13.93-13.15-.41-.17-.83-.31-1.25-.47.16-2.41.36-5.15.62-8a6.87,6.87,0,0,0,5.31,1.08c2.75-.6,4.72-2.89,6.47-5,9.24-11.35,18.73-23.18,22.28-37.28a80.54,80.54,0,0,0,2-19.2q0-.53,0-1.06A20.88,20.88,0,0,0,1016.47,153.59Z",
  transform: "translate(-79.84 -125.42)",
  fill: "url(#a3595478-8223-4729-894e-2a36a16c8458)"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M932.34,208.92s14,21,11,31,33,4,33,4,1-39,8-48S932.34,208.92,932.34,208.92Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#f7c4a7"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M839.84,222.42s-29-24-28-33c0,0-22-42-30-21s15,43,15,43l28,37Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#f7c4a7"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M810.34,598.92s-27,17-38,12-15,3-12,6,68,29,83,25,7.37-36.76,7.37-36.76Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#535461"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M953.34,671.92s-6.5,27.5-29,27c0,0-34-3-21,9s89,14,89,14,0-41-14-50S953.34,671.92,953.34,671.92Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#535461"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M912.34,477.92l3,70s0,33,11,48,24,90,24,90h38s-11-101-20-113c0,0-4-89,10-109Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#575988"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M912.34,477.92l3,70s0,33,11,48,24,90,24,90h38s-11-101-20-113c0,0-4-89,10-109Z",
  transform: "translate(-79.84 -125.42)",
  opacity: 0.1
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M991.34,414.92s23,55-19,71-118,14-118,14l-4,116s-47,6-48-9v-127s1-14,32-26,73-18,73-18l2-26Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#575988"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M954.49,233.73a47.85,47.85,0,0,1,23.5,3.32c6.13,2.58,12,6.63,13.36,12.86,1.58,7.38-.17,23.93-2.18,37.94a261.28,261.28,0,0,0-1.22,66.29c1,9.19,2.45,17.2,4.4,20.77,6,11,12,63,12,63s-66-25-99-10c0,0-4.5-102.5-5-136-.39-25.94,32.5-55.5,43.5-56.5C950.29,234.83,948.08,234.4,954.49,233.73Z",
  transform: "translate(-79.84 -125.42)",
  opacity: 0.1
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M954.49,231.73a47.85,47.85,0,0,1,23.5,3.32c6.13,2.58,12,6.63,13.36,12.86,1.58,7.38-.17,23.93-2.18,37.94a261.28,261.28,0,0,0-1.22,66.29,107.53,107.53,0,0,0,4.4,20.77c4.5,13.5,12,63,12,63s-66-25-99-10c0,0-4.5-102.5-5-136-.39-25.94,32.5-55.5,43.5-56.5C950.29,232.83,948.08,232.4,954.49,231.73Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#e14b5a"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M972.34,286.92l-71-4s-4.52-34.81,5.73-34.45l70.27,2.45S992.34,268.92,972.34,286.92Z",
  transform: "translate(-79.84 -125.42)",
  opacity: 0.1
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M972.34,284.92l-81-4s-63-19-81-40c0,0,1-37,21-39l47.31,34.69a51.08,51.08,0,0,0,28.42,9.86l70.27,2.45S992.34,266.92,972.34,284.92Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#e14b5a"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M975.84,213.42c1.19-9.48,5.49-12.63,8.5-16.5,7-9-52,13-52,13a106.08,106.08,0,0,1,8,14.71,35.85,35.85,0,0,0,15,3.29C964,227.92,969.62,218.55,975.84,213.42Z",
  transform: "translate(-79.84 -125.42)",
  opacity: 0.1
});

var _ref106 = /*#__PURE__*/React.createElement("circle", {
  cx: 875.5,
  cy: 65.5,
  r: 36,
  fill: "#f7c4a7"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M932.61,165.69c-3.83-4.19-5.68-9.77-7.42-15.18l-4-12.39c5.42,3.2,11.2-4,17.42-5,4.45-.71,8.66,1.89,12.76,3.76,17.8,8.14,41,4.1,55.32,17.43a16,16,0,0,1,4.42,6.25,20.91,20.91,0,0,1,.8,7,80.32,80.32,0,0,1-1.87,18.78c-3.4,13.79-12.5,25.37-21.37,36.47-1.68,2.11-3.57,4.35-6.21,4.94-5.15,1.15-9.13-4.41-11.12-9.29a98.9,98.9,0,0,1-5.8-20.07c-.52-2.91-.93-5.91-2.38-8.48-3.1-5.49-10.74-10.69-15.38-14.95S936.87,170.34,932.61,165.69Z",
  transform: "translate(-79.84 -125.42)",
  opacity: 0.1
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M932.61,164.69c-3.83-4.19-5.68-9.77-7.42-15.18l-4-12.39c5.42,3.2,11.2-4,17.42-5,4.45-.71,8.66,1.89,12.76,3.76,17.8,8.14,41,4.1,55.32,17.43a16,16,0,0,1,4.42,6.25,20.91,20.91,0,0,1,.8,7,80.32,80.32,0,0,1-1.87,18.78c-3.4,13.79-12.5,25.37-21.37,36.47-1.68,2.11-3.57,4.35-6.21,4.94-5.15,1.15-9.13-4.41-11.12-9.29a98.9,98.9,0,0,1-5.8-20.07c-.52-2.91-.93-5.91-2.38-8.48-3.1-5.49-10.74-10.69-15.38-14.95S936.87,169.34,932.61,164.69Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#632652"
});

var _ref109 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 885,
  cy: 69.5,
  rx: 3,
  ry: 6.5,
  fill: "#f7c4a7"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M982.84,368.42s-2,6-12,5-39-3-39,0",
  transform: "translate(-79.84 -125.42)",
  opacity: 0.1
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M903.34,706.92c-1.8-1.66-2.7-3-2.91-4.17-.26,1.3.54,3,2.91,5.17,13,12,89,14,89,14s0-.35,0-1C991.85,720.91,916.3,718.88,903.34,706.92Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#fff",
  opacity: 0.5
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M843.34,639.92c-15,4-80-22-83-25a3.25,3.25,0,0,1-.83-1.46,3.6,3.6,0,0,0,.83,3.46c3,3,68,29,83,25,7.72-2.06,9.44-11.73,9.3-20.64C852.49,629.58,850.48,638,843.34,639.92Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#fff",
  opacity: 0.5
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M581.93,629.16a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#67647e"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M171.33,602.63s37.32-1.15,48.56-9.16,57.4-17.57,60.19-4.73S336.17,652.62,294,653s-97.89-6.56-109.12-13.4S171.33,602.63,171.33,602.63Z",
  transform: "translate(-79.84 -125.42)",
  fill: "#a8a8a8"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M294.79,648.49c-42.13.34-97.89-6.56-109.12-13.4-8.55-5.21-12-23.89-13.09-32.51l-1.25,0s2.36,30.1,13.59,36.93S251.91,653.3,294,653c12.16-.1,16.36-4.42,16.13-10.83C308.48,646,303.84,648.42,294.79,648.49Z",
  transform: "translate(-79.84 -125.42)",
  opacity: 0.2
});

var _ref116 = /*#__PURE__*/React.createElement("rect", {
  x: 1017.16,
  y: 657.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(2057.48 1230.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref117 = /*#__PURE__*/React.createElement("rect", {
  x: 1017.16,
  y: 657.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(2057.48 1230.74) rotate(-180)",
  opacity: 0.1
});

var _ref118 = /*#__PURE__*/React.createElement("rect", {
  x: 937.32,
  y: 493.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

var _ref119 = /*#__PURE__*/React.createElement("rect", {
  x: 1017.16,
  y: 577.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(2057.48 1070.74) rotate(-180)",
  fill: "#00a08f"
});

var _ref120 = /*#__PURE__*/React.createElement("rect", {
  x: 1017.16,
  y: 577.58,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  transform: "translate(2057.48 1070.74) rotate(-180)",
  opacity: 0.1
});

var _ref121 = /*#__PURE__*/React.createElement("rect", {
  x: 937.32,
  y: 411.16,
  width: 103,
  height: 41,
  rx: 8.84,
  ry: 8.84,
  fill: "#00a08f"
});

function SvgCreation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "55370fff-d7e2-4a7c-8080-55f1e259b78c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1040.32,
    height: 649.16,
    viewBox: "0 0 1040.32 649.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "building_blocks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreation);
export default __webpack_public_path__ + "static/media/creation.9bdab8d9.svg";
export { ForwardRef as ReactComponent };